<template>
  <vs-button
    class="payment-settlement-button"
    :type="buttonType"
    :disabled="disabled || isSettlingPayment"
    @click.stop="handlePaymentSettlement"
    :class="className"
    :color="color"
    :style="sx"
  >
    <div v-if="isSettlingPayment" class="flex items-center justify-center">
      <loader :color="loaderColor" size="8px" />
    </div>
    <span v-else>{{ title }}</span>
  </vs-button>
</template>

<script>
import Loader from "@/components/Loader.vue";
import orderApiService from "@/services/api/OrderApiService";
import { mapGetters } from "vuex";

export default {
  name: "PaymentSettlementButton",
  components: {
    Loader,
  },
  props: {
    orderId: {
      type: Number,
      required: true,
    },
    shopId: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: "تسویه",
    },
    variant: {
      type: String,
      default: "contained", // text, outlined, contained
      validator: (value) => ["text", "outlined", "contained"].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    sx: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isSettlingPayment: false,
    };
  },
  computed: {
    ...mapGetters("profile", ["currentProvider"]),
    selectedShopId() {
      return this.shopId ?? this.currentProvider?.id;
    },
    buttonType() {
      switch (this.variant) {
        case "text":
          return "flat";
        case "outlined":
          return "border";
        case "contained":
        default:
          return "filled";
      }
    },
    loaderColor() {
      if (this.buttonType === "filled") return "#ffffff";
      return "currentColor";
    },
  },
  methods: {
    async handlePaymentSettlement() {
      if (this.disabled || this.isSettlingPayment) return;

      if (!this.selectedShopId) {
        this.$vs.notify({
          text: "فروشگاه انتخاب نشده است",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.isSettlingPayment = true;

      try {
        await orderApiService.settlePayment(this.selectedShopId, this.orderId);

        this.$vs.notify({
          text: "فاکتور با موفقیت تسویه شد.",
          color: "success",
          position: "bottom-center",
        });

        this.$emit("success");
      } catch (error) {
        this.$vs.notify({
          text: error.response?.data?.message || "خطا در تسویه فاکتور",
          color: "danger",
          position: "bottom-center",
        });
      } finally {
        this.isSettlingPayment = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* Add any specific styles if needed */

.payment-settlement-button {
  @media screen and (max-width: 768px) {
    display: none;
  }
}
</style>
